import { render, staticRenderFns } from "./form_shipping_window_invitation_data.vue?vue&type=template&id=37bb49d3&scoped=true"
import script from "./form_shipping_window_invitation_data.vue?vue&type=script&lang=js"
export * from "./form_shipping_window_invitation_data.vue?vue&type=script&lang=js"
import style0 from "./form_shipping_window_invitation_data.vue?vue&type=style&index=0&id=37bb49d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bb49d3",
  null
  
)

export default component.exports